import styled from 'styled-components'

import { Link } from 'gatsby';

import { Colors, Breakpoints } from './../../utils/variables'

export const StyledLink = styled(Link)`
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 0.5px;

    color: ${Colors.black};

    text-transform: uppercase;

    transition: opacity 0.15s ease-out;

    &:hover {
        opacity: 0.5;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        font-size: 13px;
    }
`